function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.305.004H4.08c-.625 0-1.175.375-1.4.95L.055 7.73c-.2.5.175 1.025.7 1.025h4.3l-1.6 5.6c-.15.525.5.875.85.45l6.575-7.8c.425-.475.075-1.25-.575-1.25h-3.25l2.85-4.6c.3-.5-.05-1.15-.65-1.15h-.95z",
  fill: "#fff"
});

var SvgLightningBolt = function SvgLightningBolt(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='12' height='15' viewBox='0 0 12 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M8.30466 0.00415039H4.07966C3.45466 0.00415039 2.90466 0.37915 2.67966 0.95415L0.0546577 7.72915C-0.145342 8.22915 0.229658 8.75415 0.754658 8.75415H5.05466L3.45466 14.3542C3.30466 14.8792 3.95466 15.2292 4.30466 14.8042L10.8797 7.00415C11.3047 6.52915 10.9547 5.75415 10.3047 5.75415H7.05466L9.90466 1.15415C10.2047 0.65415 9.85466 0.00415039 9.25466 0.00415039H8.30466V0.00415039Z' fill='white'/%3E %3C/svg%3E";
export { SvgLightningBolt as ReactComponent };